export default __webpack_public_path__ + "static/media/masjid img6.aeb0cbf1.jpg";